import React, { useState, useEffect } from "react";

/**
 * Floating WhatsApp action button, fixed to bottom-right on every page.
 * Appears after a small scroll and includes a soft pulse + label on hover.
 */
const WA_NUMBER = "6287777881016";
const WA_MSG = "Halo%20Across%20Indonesia%2C%20saya%20ingin%20konsultasi%20perjalanan.";

const WhatsAppIcon = ({ size = 26 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.05 4.92A10 10 0 0 0 4.07 18.34L3 22l3.78-1.05A10 10 0 1 0 19.05 4.92Zm-7.04 15.32a8.27 8.27 0 0 1-4.23-1.16l-.3-.18-2.24.62.6-2.18-.2-.32a8.32 8.32 0 1 1 6.37 3.22Zm4.55-6.22c-.25-.13-1.47-.72-1.69-.8-.23-.08-.4-.13-.56.13-.16.25-.65.8-.79.97-.15.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23a7.5 7.5 0 0 1-1.38-1.72c-.15-.25-.02-.39.1-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.16.04-.31-.02-.43-.07-.13-.56-1.35-.76-1.85-.2-.49-.41-.42-.56-.43h-.48a.93.93 0 0 0-.67.31c-.23.25-.88.86-.88 2.1 0 1.24.9 2.43 1.02 2.6.13.16 1.77 2.7 4.29 3.79.6.26 1.06.41 1.43.52a3.46 3.46 0 0 0 1.58.1c.48-.07 1.47-.6 1.68-1.18.21-.59.21-1.09.15-1.19-.06-.1-.23-.16-.48-.29Z" />
  </svg>
);

export default function FloatingWhatsApp() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 200);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_MSG}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
      className={`group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      {/* Pulse halo */}
      <span className="absolute inset-0 rounded-full bg-emerald-500/40 animate-ping" aria-hidden />
      {/* Button */}
      <span className="relative flex items-center gap-2 pl-2.5 pr-2.5 md:pr-5 py-2.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-xl ring-1 ring-emerald-700/20">
        <span className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center shrink-0">
          <WhatsAppIcon />
        </span>
        <span className="hidden md:inline-block max-w-0 md:max-w-[200px] overflow-hidden transition-all duration-500 group-hover:max-w-[260px] whitespace-nowrap text-sm font-medium pr-1">
          Chat on WhatsApp
        </span>
      </span>
    </a>
  );
}
